import { Component, Input, OnInit } from "@angular/core";
import { EventService } from "../event-service/event.service";
import { FeatureFlagService } from "../feature-flag/feature-flag.service";

@Component({
  templateUrl: "./project-nav.component.html",
})
export class ProjectNavComponent implements OnInit {
  @Input() public project: any;
  @Input() public user: any;
  public getexceptional: boolean;

  constructor(
    private eventService: EventService,
    private featureFlagService: FeatureFlagService,
  ) {}

  public ngOnInit() {
    // TODO: remove when project alerts & JS performance are ready to be released.
    this.getexceptional = this.featureFlagService.getexceptional();
  }

  public select() {
    this.eventService.publish("project-nav:linkSelected");
  }
}
